import { trpcSwr } from '../../../../api/trpc';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { ModalProps } from '../../../../services/modals.service';
import { useForm } from 'react-hook-form';
import { AlertService } from '../../../../services/alert.service';
import { required } from '../../../../utils/validations';
import { InputWrapper } from '../../../common/input-wrapper';
import React from 'react';

type Props = ModalProps & {
  orderId: string;
};

export const CustomsDeliverySentToRevisionModal: React.FC<Props> = (props) => {
  const { trigger: sentToRevision } =
    trpcSwr.customsDelivery.sentToRevision.useSWRMutation({
      onError: (e) => {
        toast.error(e.message);
      },
    });

  const { handleSubmit, register, formState } = useForm<{
    comment: string;
  }>({});

  const onSubmit = handleSubmit(async (form) => {
    await sentToRevision({
      id: props.orderId,
      comment: form.comment,
    });
    props.close();
    AlertService.success();
  });

  return (
    <div className="modal-dialog">
      <div className={'modal-content'}>
        <div className="modal-header border-bottom-0 p-4">
          <h3>
            <FormattedMessage
              defaultMessage="Отправить на доработку?"
              id="customsDeliveryOrderGoodEditModal.input.title"
              description="Заголовок модального окна"
            />
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.reject()}
          />
        </div>
        <form>
          <div className="modal-body pt-2 px-4 pb-2">
            <InputWrapper
              title="Комментарий"
              className="mb-4"
              error={formState.errors.comment?.message}
              required
            >
              <textarea
                style={{ minHeight: '200px' }}
                placeholder="Укажите комментарий"
                className="form-control fs-16 lh-sm"
                {...register('comment', { ...required })}
              />
            </InputWrapper>
          </div>

          <div className="mx-1 d-flex flex-row justify-content-center mb-2">
            <div
              className="btn btn-success w-50"
              onClick={() => {
                onSubmit();
              }}
            >
              Отправить
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
